import { useTheme } from 'styled-components';
import { PulseCheckTheme } from '../PulseCheck.meta';

export const usePulseCheckTheme = () => {
  return useTheme() as PulseCheckTheme;
};
